import React from 'react';

export default function AboutMe() {
  return (
    <article className="article">
      <header className="article__head">
        <p className="eyebrow">About</p>
        <h1 className="article__title">Usman Mehr</h1>
        <p className="article__lede">
          Gardener in the South of England. Fruit trees, over 35 roses, dahlias,
          and a vegetable patch worked around a full-time job.
        </p>
      </header>

      <div className="prose">
        <p className="lead">
          I grew up in a city, but ask anyone in my family and they&rsquo;ll tell you
          gardening is in my blood.
        </p>

        <p>
          Both my grandparents were farmers, and looking back, that&rsquo;s clearly where
          this all started. My paternal grandfather had a mango orchard, and he was known
          for something quite special: his grafting skills. People would travel from
          far-flung places just to have him graft their plants for them. My dad spent his
          younger days helping out in that same orchard. Alongside the mangoes, my
          grandfather grew loquats, mulberries and grapefruits, and the path leading up to
          it all had rose bushes running along one side.
        </p>

        <p>
          My maternal grandfather worked the land differently, growing vegetables -
          brassicas, spinach, carrots, sugar cane. Some of my best childhood memories are
          from holidays spent visiting my grandparents in the village, picking fresh
          produce straight off the plant and eating it right there.
        </p>

        <p>
          My dad had his own thing too - roses, and anything fragrant. So really, this
          love of nature just runs right through the family.
        </p>

        <h2>My own garden today</h2>

        <p>
          Now it&rsquo;s my turn. In my own garden I grow flowers and vegetables, though
          between work and everything else, spare time is hard to come by. I still do my
          best - keeping a tidy lawn, growing a few vegetables through the summer. I&rsquo;ve
          got cherry, pear, fig, plum and olive trees, and over 35 rose plants (yes,
          really). Dahlias are a favourite, along with hanging baskets full of petunias. I
          also grow begonias, hydrangeas, montbretia, gladioli and sweet peas.
        </p>

        <p>
          I try to garden organically where I can - making my own compost, picking up
          horse manure whenever I get the chance. I even grow marigolds on purpose, just
          to bring in ladybirds, who take care of the aphids for me.
        </p>

        <p>
          That&rsquo;s me, really. I love nature, plants, growing things. And if I ever got
          a second shot at a different career, I&rsquo;d want to be a farmer.
        </p>

        <blockquote className="pullquote">
          <p>
            &hellip;and then my heart with pleasure fills,<br />
            And dances with the daffodils.
          </p>
          <cite>William Wordsworth, <em>Daffodils</em></cite>
        </blockquote>

        <p className="signature">Usman Mehr</p>
      </div>
    </article>
  );
}
